import axios from "const/axios";

// ========= Client & feedback =========

export const addClientToFeedback = async (payload) => {
  const res = await axios.post("follow-up", payload);
  return res?.data?.data;
};

export const getFeedbackClients = async () => {
  // The backend paginates this endpoint (default size=10) — without an explicit size this
  // silently truncated the follow-up queue to the first 10 records. Both consumers
  // (FollowupClientSelector's duplicate-check, FollowupTable's listing) need the full queue,
  // which is bounded by design (items leave once resolved), so one bounded page covers it.
  // TODO: Add proper pagination support
  const res = await axios.get("follow-up", { params: { size: 500 } });
  return res?.data?.data?.content || [];
};

export const getFeedbackClientDetails = async (followUpId) => {
  const res = await axios.get(`follow-up/${followUpId}`);
  return res?.data?.data;
};

export const removeClientFromFeedback = async (clientId) => {
  const res = await axios.delete(`follow-up/${clientId}`);
  return res?.data?.data;
};

export const getClientDetails = async (clientId) => {
  const res = await axios.get(`clients/${clientId}`);
  return res?.data?.data;
};

export const updateClientFeedback = async (clientId, data) => {
  const res = await axios.put(`clients/${clientId}/feedback`, data);
  return res?.data?.data;
};

export const sendReviewForm = async (clientId) => {
  const res = await axios.post(`clients/${clientId}/send-review-form`);
  return res?.data?.data;
};

export const sendFollowUpEmail = async (followUpId, templateName) => {
  const res = await axios.post(`follow-up/${followUpId}/send-email`, null, {
    params: { templateName },
  });
  return res?.data?.data ?? res?.data;
};

// ========= Discussions =========

export const getDiscussionHistory = async (followUpId) => {
  const res = await axios.get(`follow-up/${followUpId}/discussions`);
  return res?.data?.data || [];
};

export const deleteDiscussionComment = async (followUpId, commentId) => {
  const res = await axios.delete(`follow-up/${followUpId}/discussions/${commentId}`);
  return res?.data?.data;
};

export const addDiscussion = async (followUpId, payload) => {
  const res = await axios.post(`follow-up/${followUpId}/discussions`, {
    ...payload,
  });
  return res?.data?.data;
};

export const sendNotification = async (followUpId, data) => {
  console.log(data);
  const res = await axios.post(`follow-up/${followUpId}/notify-user`, data);
  return res?.data?.data;
};
